import { DEFAULT_GITHUB_INSTANCE_SLUG } from "@/lib/named-org";

export interface GithubLink {
  instance_slug: string | null;
  username: string | null;
}

/**
 * The GitHub login to show for a user: their github.com identity when it has
 * a username, otherwise the first linked identity that does.
 */
export function githubLogin(
  user: { github_links?: GithubLink[] } | null | undefined,
): string | null {
  const links = (user?.github_links ?? []).filter((l) => l.username);
  const link =
    links.find((l) => l.instance_slug === DEFAULT_GITHUB_INSTANCE_SLUG) ??
    links[0];
  return link?.username ?? null;
}
